import { FormikProps, useFormik } from 'formik';
import { IBiography, ISocialMediaAttributes, ITalentUpdatePayload } from 'shared/interfaces/ITalent';
import Social from 'data/Social.json';
type FormProps = {
  onSubmit: (values: ITalentUpdatePayload) => void;
  data: ISocialMediaAttributes[] | undefined;
};

export const useSocialForm = ({ onSubmit, data }: FormProps) => {
  const initialValues: ITalentUpdatePayload = {
    social_media_accounts: typeof data === 'string' ? Social : data,
  };

  const form: FormikProps<ITalentUpdatePayload> = useFormik({
    initialValues,
    onSubmit: (values) => onSubmit(values),
    enableReinitialize: true,
  });

  return {
    form,
  };
};
